module.exports = require("lodash");


/*****************
 ** WEBPACK FOOTER
 ** external "lodash"
 ** module id = 42
 ** module chunks = 0
 **/